import _extends from '@babel/runtime/helpers/esm/extends'
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose'
var _excluded = ['className', 'children']
import css from 'dom-helpers/css'
import transitionEnd from 'dom-helpers/transitionEnd'

var _fadeStyles

import classNames from 'classnames'
import React, { useCallback } from 'react'
import Transition, { ENTERED, ENTERING } from 'react-transition-group/Transition'

var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
}
var fadeStyles =
  ((_fadeStyles = {}),
  (_fadeStyles[ENTERING] = 'show'),
  (_fadeStyles[ENTERED] = 'show'),
  _fadeStyles)

function parseDuration(node, property) {
  var str = css(node, property) || ''
  var mult = str.indexOf('ms') === -1 ? 1000 : 1
  return parseFloat(str) * mult
}

function transitionEndListener(element, handler) {
  var duration = parseDuration(element, 'transitionDuration')
  var delay = parseDuration(element, 'transitionDelay')
  var remove = transitionEnd(
    element,
    function (e) {
      if (e.target === element) {
        remove()
        handler(e)
      }
    },
    duration + delay
  )
}

function triggerBrowserReflow(node) {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  node.offsetHeight
}

var Fade = /*#__PURE__*/ React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded)

  var handleEnter = useCallback(
    function (node) {
      triggerBrowserReflow(node)
      if (props.onEnter) props.onEnter(node)
    },
    [props]
  )
  return /*#__PURE__*/ React.createElement(
    Transition,
    _extends(
      {
        ref: ref,
        addEndListener: transitionEndListener,
      },
      props,
      {
        onEnter: handleEnter,
      }
    ),
    function (status, innerProps) {
      return /*#__PURE__*/ React.cloneElement(
        children,
        _extends({}, innerProps, {
          className: classNames('fade', className, children.props.className, fadeStyles[status]),
        })
      )
    }
  )
})
Fade.defaultProps = defaultProps
Fade.displayName = 'Fade'
export default Fade
